import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-subtitle-2 mb-2 d-block" }
const _hoisted_2 = {
  "aria-live": "polite",
  style: {"font-weight":"bold"}
}
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = { class: "ml-1" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { type MonthType, MONTHS } from './date_time_range_generators';

const monthItemWidthPx = 110;

export default /*@__PURE__*/_defineComponent({
  __name: 'MonthsPicker',
  props: /*@__PURE__*/_mergeModels({
    showErrorForEmpty: { type: Boolean }
  }, {
    "modelValue": {
  type: Array as () => MonthType[]
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const selectedMonths = _useModel<MonthType[]>(__props, "modelValue");

const empty = computed(() => selectedMonths.value?.length === 0);

const columns = ref(1);
const cssVars = computed(() => ({
  '--column-count': columns.value
}));
const observer = new ResizeObserver(() => {
  updateColumnCount();
});

function updateColumnCount() {
  const container = document.getElementById('dtrs-months-picker') ;
  if (container) {
    columns.value = Math.max(Math.floor(container.clientWidth / monthItemWidthPx), 1);
  }
}
onMounted(() => {
  updateColumnCount();
  const container = document.getElementById('dtrs-months-picker') ;
  if (container) {
    observer.observe(container);
  }
});

onBeforeUnmount(() => {
  observer.disconnect();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "dtrs-months-picker",
    class: _normalizeClass({'dtrs-error-highlight': __props.showErrorForEmpty && empty.value})
  }, [
    _createElementVNode("label", _hoisted_1, [
      _cache[1] || (_cache[1] = _createTextVNode("Months ", -1)),
      _withDirectives(_createElementVNode("span", _hoisted_2, " (Select at least 1) ", 512), [
        [_vShow, __props.showErrorForEmpty && empty.value]
      ])
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle(cssVars.value),
      class: "dtrs-months-block"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MONTHS), (month) => {
        return (_openBlock(), _createElementBlock("div", { key: month }, [
          _createElementVNode("label", {
            class: "mr-3",
            style: {"text-wrap":"nowrap"},
            for: `dtrs-month-${month}`
          }, [
            _withDirectives(_createElementVNode("input", {
              id: `dtrs-month-${month}`,
              type: "checkbox",
              value: month,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMonths).value = $event))
            }, null, 8, _hoisted_4), [
              [_vModelCheckbox, selectedMonths.value]
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(month), 1)
          ], 8, _hoisted_3)
        ]))
      }), 128))
    ], 4)
  ], 2))
}
}

})